"use strict";
/**
 * @hyb/i18n - Translation Resources
 * Centralized locale files for HYB Shop
 *
 * Usage in React Native (with react-i18next):
 * ```ts
 * import { resources, fallbackLng } from '@hyb/i18n';
 * import i18n from 'i18next';
 * import { initReactI18next } from 'react-i18next';
 *
 * i18n.use(initReactI18next).init({
 *   resources,
 *   lng: 'th',
 *   fallbackLng,
 * });
 * ```
 *
 * Usage in Web Dashboard (with react-i18next):
 * ```ts
 * import { resources, fallbackLng } from '@hyb/i18n';
 * import i18n from 'i18next';
 * import { initReactI18next } from 'react-i18next';
 *
 * i18n.use(initReactI18next).init({
 *   resources,
 *   lng: 'th',
 *   fallbackLng,
 * });
 * ```
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.locales = exports.en = exports.th = exports.supportedLngs = exports.fallbackLng = exports.defaultNS = exports.resources = void 0;
// Import locale files (compiled from JSON)
const th_json_1 = __importDefault(require("../locales/th.json"));
exports.th = th_json_1.default;
const en_json_1 = __importDefault(require("../locales/en.json"));
exports.en = en_json_1.default;
/**
 * i18next-compatible resources object
 */
exports.resources = {
    th: { translation: th_json_1.default },
    en: { translation: en_json_1.default },
};
/**
 * Default namespace
 */
exports.defaultNS = 'translation';
/**
 * Fallback language
 */
exports.fallbackLng = 'th';
/**
 * Supported languages
 */
exports.supportedLngs = ['th', 'en'];
exports.locales = { th: th_json_1.default, en: en_json_1.default };
